var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderTree = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5004 1.50276C1.94714 1.50276 1.50374 1.94616 1.50374 2.49943V17.9994C1.50374 18.5527 1.94714 18.9961 2.5004 18.9961H20.5004C21.0537 18.9961 21.4971 18.5527 21.4971 17.9994V4.99943C21.4971 4.44616 21.0537 4.00276 20.5004 4.00276H9.9129C9.51606 4.00276 9.13203 3.84288 8.85074 3.56159L6.93824 1.64909C6.84453 1.55538 6.71606 1.50276 6.5879 1.50276H2.5004ZM0.49707 2.49943C0.49707 1.39019 1.39117 0.496094 2.5004 0.496094H6.5879C6.98474 0.496094 7.36877 0.655975 7.65006 0.937267L9.56256 2.84977C9.65627 2.94347 9.78474 2.99609 9.9129 2.99609H20.5004C21.6096 2.99609 22.5037 3.89019 22.5037 4.99943V17.9994C22.5037 19.1087 21.6096 20.0028 20.5004 20.0028H2.5004C1.39117 20.0028 0.49707 19.1087 0.49707 17.9994V2.49943Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderTree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder_tree.c3c1744aa20e2a6cfb6e91eb1d3a6fac.svg";